import { render, staticRenderFns } from "./TransferMarketView.vue?vue&type=template&id=0ac2d691&scoped=true&"
import script from "./TransferMarketView.vue?vue&type=script&lang=js&"
export * from "./TransferMarketView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac2d691",
  null
  
)

export default component.exports